/* ==================================================================
   YEVANJEL — motion.js
   성능 원칙
   · 스크롤 중에는 레이아웃을 절대 읽지 않는다.
     위치·크기는 로드/리사이즈 때 한 번만 재서 캐시하고,
     매 프레임에는 transform / opacity 같은 합성 속성만 쓴다.
   · 모든 스크롤 작업은 하나의 rAF 안에서 처리한다.
   ================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  var S = window.yvSettings || {};

  function on(key) { return S[key] === undefined ? true : !!S[key]; }

  // 기기가 버거우면 무거운 장식을 스스로 끈다
  var cores = navigator.hardwareConcurrency || 8;
  var mem = navigator.deviceMemory || 8;
  var lowEnd = cores <= 4 || mem <= 4 || window.matchMedia('(pointer: coarse)').matches;
  if (S.performanceMode === true) lowEnd = true;
  if (S.performanceMode === false) lowEnd = false;
  if (lowEnd) root.classList.add('yv-lite');

  if (reduce || !('IntersectionObserver' in window)) {
    root.classList.remove('yv-motion');
    root.classList.add('yv-intro-done');
    return;
  }

  var scrollY = window.pageYOffset;
  var vh = window.innerHeight;
  var vw = window.innerWidth;
  var docH = 1;

  /* ================= 인트로 ================= */

  var INTRO_END = window.yvIntroEnd || 3900;

  function finishIntro() {
    if (root.classList.contains('yv-intro-done')) return;
    root.classList.remove('yv-intro-active', 'yv-intro-skip', 'yv-intro-reveal');
    root.classList.add('yv-intro-done');
    var el = document.getElementById('yv-intro');
    if (el && el.parentNode) el.parentNode.removeChild(el);
    measure();
  }

  function skipIntro() {
    if (!root.classList.contains('yv-intro-active')) return;
    revealPage();
    root.classList.add('yv-intro-skip');
    setTimeout(finishIntro, 520);
  }

  function revealPage() {
    if (root.classList.contains('yv-intro-reveal')) return;
    root.classList.add('yv-intro-reveal');   // 커튼 뒤에서 페이지를 먼저 그려 둔다
    measure();
  }

  if (root.classList.contains('yv-intro-active')) {
    setTimeout(revealPage, 2450);
    setTimeout(finishIntro, INTRO_END);
    var introEl = document.getElementById('yv-intro');
    if (introEl) {
      introEl.style.pointerEvents = 'auto';
      introEl.addEventListener('click', skipIntro);
    }
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') skipIntro();
    });
    window.addEventListener('wheel', skipIntro, { passive: true, once: true });
    window.addEventListener('touchmove', skipIntro, { passive: true, once: true });
  } else {
    root.classList.add('yv-intro-done');
  }

  /* ================= 등장 옵저버 ================= */

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        var el = entries[i].target;
        el.classList.add('yv-in');
        io.unobserve(el);
        (function (node) {
          setTimeout(function () {
            node.removeAttribute('data-yv-reveal');
            node.style.removeProperty('--yv-delay');
            node.style.willChange = 'auto';
          }, 1700);
        })(el);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.06 }
  );

  /* ================= 헤딩 단어 쪼개기 ================= */

  function splitHeading(el) {
    if (el.getAttribute('data-yv-split') === 'done') return false;
    for (var i = 0; i < el.childNodes.length; i++) {
      if (el.childNodes[i].nodeType !== 3) return false;
    }
    var words = el.textContent.trim().split(/\s+/);
    if (!words.length || words.length > 40) return false;

    var html = '';
    for (var w = 0; w < words.length; w++) {
      html += '<span class="yv-split__word"><span class="yv-split__inner" style="--w:' + w + '">' +
        words[w].replace(/[&<>]/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c];
        }) + '</span></span>';
      if (w < words.length - 1) html += ' ';
    }
    el.innerHTML = html;
    el.classList.add('yv-split');
    el.setAttribute('data-yv-split', 'done');
    return true;
  }

  /* ================= 섹션 태깅 ================= */

  var REVEAL_SELECTOR = 'h1,h2,h3,h4,p,li,[class*="button"],a.theme-cta,button,form,img,picture,video,svg.placeholder-svg';
  var HEADING_SELECTOR = 'h1, h2, h3, .text-heading-feature';

  var parallaxItems = [];

  function tagSection(section) {
    if (section.hasAttribute('data-yv-tagged')) return;
    section.setAttribute('data-yv-tagged', '');

    if (section.querySelector('[data-yv-custom]') || section.hasAttribute('data-yv-custom')) {
      section.classList.add('yv-ready');
      return;
    }

    var isHero = /hero$/.test(section.id || '');

    if (isHero) {
      var heads = section.querySelectorAll(HEADING_SELECTOR);
      for (var h = 0; h < heads.length; h++) {
        if (on('splitHeadings') && splitHeading(heads[h])) heads[h].classList.add('yv-in');
      }
      section.classList.add('yv-ready');
      return;
    }

    var found = section.querySelectorAll(REVEAL_SELECTOR);
    var targets = [];
    for (var i = 0; i < found.length; i++) {
      var el = found[i];
      if (el.closest('[data-yv-reveal]')) continue;
      if (el.closest('.yv-deck, .yv-wordmark, .yv-sticky, [data-yv-custom]')) continue;
      targets.push(el);
    }
    if (!targets.length) targets = [section];

    for (var k = 0; k < targets.length; k++) {
      var t = targets[k];
      var isMedia = /^(IMG|PICTURE|VIDEO|SVG)$/.test(t.tagName);
      if (!isMedia && t.matches(HEADING_SELECTOR) && on('splitHeadings') && splitHeading(t)) {
        io.observe(t);
      } else {
        t.setAttribute('data-yv-reveal', isMedia ? 'media' : 'text');
        t.style.setProperty('--yv-delay', Math.min(k, 6) * 0.07 + 's');
        io.observe(t);
      }
      if (isMedia && on('parallax') && !lowEnd) parallaxItems.push({ el: t, top: 0, h: 0, speed: 0.045 });
    }

    section.classList.add('yv-ready');
  }

  function tagAll() {
    var secs = document.querySelectorAll('#MainContent > [id^="shopify-section"]');
    for (var i = 0; i < secs.length; i++) tagSection(secs[i]);
  }

  /* ================= 컴포넌트 등록 ================= */

  var decks = [], hscrolls = [], stories = [], masks = [], colsets = [], splitsts = [];
  var counts = [], peeks = [];
  var sticky = null, stickyAfter = 0.4, signupZones = [];
  var marquee = null, progress = null, ringTop = null, cursor = null;

  function initSeams() {
    if (root.classList.contains('yv-seamless')) return;
    var secs = document.querySelectorAll('#MainContent > [id^="shopify-section"] > section');
    for (var i = 1; i < secs.length; i++) {
      if (secs[i].querySelector(':scope > .yv-seam')) continue;
      if (window.getComputedStyle(secs[i]).position === 'static') secs[i].style.position = 'relative';
      var seam = document.createElement('span');
      seam.className = 'yv-seam';
      seam.setAttribute('aria-hidden', 'true');
      secs[i].insertBefore(seam, secs[i].firstChild);
    }
  }

  function joinCreamRuns() {
    var secs = document.querySelectorAll('#MainContent > [id^="shopify-section"] > section');
    for (var i = 0; i < secs.length; i++) {
      if (!secs[i].hasAttribute('data-yv-cream')) continue;
      var prev = i > 0 ? secs[i - 1] : null;
      var next = i < secs.length - 1 ? secs[i + 1] : null;
      var bed = secs[i].querySelector(':scope > .yv-cream-bed');
      if (!bed) continue;
      if (prev && prev.hasAttribute('data-yv-cream')) bed.classList.add('yv-cream-bed--no-top');
      if (next && next.hasAttribute('data-yv-cream')) bed.classList.add('yv-cream-bed--no-bottom');
    }
  }

  function initTickers() {
    var rows = document.querySelectorAll('.yv-ticker__track:not([data-yv-t-ready]), .yv-social__track:not([data-yv-t-ready]), .yv-imq__track:not([data-yv-t-ready])');
    for (var i = 0; i < rows.length; i++) {
      rows[i].setAttribute('data-yv-t-ready', '');
      rows[i].innerHTML = rows[i].innerHTML + rows[i].innerHTML;
    }
  }

  function initDecks() {
    var found = document.querySelectorAll('.yv-deck:not([data-yv-deck-ready])');
    for (var i = 0; i < found.length; i++) {
      var deck = found[i];
      deck.setAttribute('data-yv-deck-ready', '');
      var cards = deck.querySelectorAll('.yv-deck__card');
      var n = cards.length;
      for (var j = 0; j < n; j++) {
        var offset = j - (n - 1) / 2;
        cards[j].style.setProperty('--yv-rot', (offset * 4.6).toFixed(2) + 'deg');
        cards[j].style.setProperty('--yv-x', (offset * 44).toFixed(1) + '%');
        cards[j].style.setProperty('--yv-y', (Math.abs(offset) * 1.35).toFixed(2) + 'rem');
        cards[j].style.setProperty('--yv-delay', (j * 0.09).toFixed(2) + 's');
        cards[j].style.zIndex = String(10 - Math.round(Math.abs(offset)));
      }
      decks.push({ el: deck, cards: cards, top: 0, h: 0, open: false });
      io.observe(deck);
    }
  }

  function initHscroll() {
    var els = document.querySelectorAll('[data-yv-hscroll]:not([data-yv-h-ready])');
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('data-yv-h-ready', '');
      hscrolls.push({
        wrap: els[i],
        track: els[i].querySelector('[data-yv-hscroll-track]'),
        bar: els[i].querySelector('[data-yv-hscroll-bar]'),
        top: 0, h: 0, max: 0, last: -1
      });
    }
  }

  function initStory() {
    var els = document.querySelectorAll('[data-yv-story]:not([data-yv-story-ready])');
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('data-yv-story-ready', '');
      stories.push({
        wrap: els[i],
        lines: els[i].querySelectorAll('[data-yv-story-line]'),
        dots: els[i].querySelectorAll('.yv-story__dot'),
        top: 0, h: 0, current: -1
      });
    }
  }

  function initMasks() {
    var els = document.querySelectorAll('[data-yv-mask]:not([data-yv-mask-ready])');
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('data-yv-mask-ready', '');
      masks.push({
        wrap: els[i],
        shape: els[i].querySelector('[data-yv-mask-shape]'),
        img: els[i].querySelector('.yv-mask__img'),
        copy: els[i].querySelector('[data-yv-mask-copy]'),
        top: 0, h: 0, last: -1
      });
    }
  }

  function initCols() {
    var els = document.querySelectorAll('[data-yv-cols]:not([data-yv-cols-ready])');
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('data-yv-cols-ready', '');
      colsets.push({ wrap: els[i], inners: els[i].querySelectorAll('.yv-cols__inner'), top: 0, h: 0 });
    }
  }

  function initSplitStatements() {
    var els = document.querySelectorAll('[data-yv-split-statement]:not([data-yv-ss-ready])');
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('data-yv-ss-ready', '');
      splitsts.push({ el: els[i], top: 0, h: 0, last: -1 });
    }
  }

  function initWordmarks() {
    var marks = document.querySelectorAll('[data-yv-wordmark]:not([data-yv-wm-ready])');
    for (var i = 0; i < marks.length; i++) {
      marks[i].setAttribute('data-yv-wm-ready', '');
      io.observe(marks[i]);
    }
  }

  function initSignupSections() {
    var els = document.querySelectorAll('[data-yv-signup]:not([data-yv-signup-ready])');
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('data-yv-signup-ready', '');
      io.observe(els[i]);
      signupZones.push({ el: els[i], top: 0, h: 0 });
    }
  }

  function initCycles() {
    var els = document.querySelectorAll('[data-yv-cycle]:not([data-yv-cycle-ready])');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        el.setAttribute('data-yv-cycle-ready', '');
        var words = el.querySelectorAll('.yv-cycle__word');
        if (words.length < 2) return;
        var slot = el.querySelector('[data-yv-cycle-slot]');
        var widths = [];
        var idx = 0;

        function measureWords() {
          for (var k = 0; k < words.length; k++) widths[k] = words[k].getBoundingClientRect().width;
          if (slot) slot.style.width = widths[idx].toFixed(1) + 'px';
        }
        requestAnimationFrame(measureWords);
        window.addEventListener('resize', function () { requestAnimationFrame(measureWords); }, { passive: true });

        setInterval(function () {
          words[idx].classList.remove('is-on');
          words[idx].classList.add('is-out');
          var prev = idx;
          setTimeout(function () { words[prev].classList.remove('is-out'); }, 640);
          idx = (idx + 1) % words.length;
          words[idx].classList.add('is-on');
          if (slot && widths[idx]) slot.style.width = widths[idx].toFixed(1) + 'px';
        }, 2600);
      })(els[i]);
    }
  }

  function initStats() {
    var els = document.querySelectorAll('[data-yv-stats]:not([data-yv-stats-ready])');
    for (var i = 0; i < els.length; i++) {
      (function (wrap) {
        wrap.setAttribute('data-yv-stats-ready', '');
        var sio = new IntersectionObserver(function (entries) {
          for (var k = 0; k < entries.length; k++) {
            if (!entries[k].isIntersecting) continue;
            entries[k].target.classList.add('yv-in');
            var nums = entries[k].target.querySelectorAll('[data-yv-stat]');
            for (var q = 0; q < nums.length; q++) countUp(nums[q]);
            sio.unobserve(entries[k].target);
          }
        }, { threshold: 0.25 });
        sio.observe(wrap);
      })(els[i]);
    }
  }

  function countUp(node) {
    var target = parseFloat(node.getAttribute('data-yv-stat')) || 0;
    var pre = node.getAttribute('data-yv-prefix') || '';
    var suf = node.getAttribute('data-yv-suffix') || '';
    var start = performance.now();
    function step(now) {
      var t = Math.min(1, (now - start) / 1700);
      node.textContent = pre + Math.round(target * (1 - Math.pow(1 - t, 3))) + suf;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initAccordions() {
    var qs = document.querySelectorAll('[data-yv-acc-q]:not([data-yv-acc-ready])');
    for (var i = 0; i < qs.length; i++) {
      (function (q) {
        q.setAttribute('data-yv-acc-ready', '');
        q.addEventListener('click', function () {
          var item = q.closest('.yv-acc__item');
          if (!item) return;
          var open = item.classList.toggle('is-open');
          q.setAttribute('aria-expanded', open ? 'true' : 'false');
          setTimeout(measure, 700);
        });
      })(qs[i]);
    }
  }

  function initCounts() {
    var els = document.querySelectorAll('[data-yv-count]:not([data-yv-count-ready])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('data-yv-count-ready', '');
      var raw = (el.getAttribute('data-yv-target') || '').trim().replace(' ', 'T');
      var t = Date.parse(raw);
      if (isNaN(t)) t = Date.parse(raw + ':00');
      if (isNaN(t)) continue;
      counts.push({
        el: el, target: t,
        live: el.querySelector('[data-yv-count-live]'),
        clock: el.querySelector('[data-yv-clock]'),
        nums: {
          days: el.querySelector('[data-yv-unit="days"]'),
          hours: el.querySelector('[data-yv-unit="hours"]'),
          minutes: el.querySelector('[data-yv-unit="minutes"]'),
          seconds: el.querySelector('[data-yv-unit="seconds"]')
        },
        last: {}
      });
      io.observe(el);
    }
    if (counts.length) { tickCounts(); setInterval(tickCounts, 1000); }
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tickCounts() {
    var now = Date.now();
    for (var i = 0; i < counts.length; i++) {
      var c = counts[i];
      var diff = c.target - now;
      if (diff <= 0) {
        if (c.clock) c.clock.hidden = true;
        if (c.live) c.live.hidden = false;
        continue;
      }
      var s = Math.floor(diff / 1000);
      var v = { days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600),
                minutes: Math.floor((s % 3600) / 60), seconds: s % 60 };
      for (var k in v) {
        var node = c.nums[k];
        if (!node) continue;
        var txt = pad(v[k]);
        if (c.last[k] === txt) continue;
        c.last[k] = txt;
        node.textContent = txt;
        node.classList.remove('yv-tick');
        void node.offsetWidth;
        node.classList.add('yv-tick');
      }
    }
  }

  function initHoverList() {
    var lists = document.querySelectorAll('[data-yv-hover-list]:not([data-yv-hl-ready])');
    for (var i = 0; i < lists.length; i++) {
      (function (list) {
        list.setAttribute('data-yv-hl-ready', '');
        var peek = list.querySelector('[data-yv-hl-peek]');
        if (!peek) return;
        var st = { peek: peek, x: 0, y: 0, tx: 0, ty: 0, live: false };
        peeks.push(st);

        var rows = list.querySelectorAll('[data-yv-hl-row]');
        for (var k = 0; k < rows.length; k++) {
          (function (row) {
            row.addEventListener('mouseenter', function () {
              var src = row.getAttribute('data-yv-hl-image');
              if (!src) return;
              peek.style.backgroundImage = 'url("' + src + '")';
              peek.classList.add('is-on');
              st.live = true;
              wake();
            });
            row.addEventListener('mouseleave', function () {
              peek.classList.remove('is-on');
              st.live = false;
            });
          })(rows[k]);
        }
        list.addEventListener('mousemove', function (e) {
          st.tx = e.clientX; st.ty = e.clientY; wake();
        }, { passive: true });
      })(lists[i]);
    }
  }

  function initSticky() {
    sticky = document.querySelector('[data-yv-sticky]');
    if (!sticky) return;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('yv-sticky-off') === '1'; } catch (e) {}
    if (dismissed && !editor) { sticky.parentNode.removeChild(sticky); sticky = null; return; }
    stickyAfter = (parseFloat(sticky.getAttribute('data-yv-sticky-after')) || 40) / 100;
    var close = sticky.querySelector('[data-yv-sticky-close]');
    if (close) {
      close.addEventListener('click', function () {
        sticky.classList.remove('yv-on');
        try { sessionStorage.setItem('yv-sticky-off', '1'); } catch (e) {}
      });
    }
    if (sticky.querySelector('.yv-sticky__done')) {
      try { sessionStorage.setItem('yv-sticky-off', '1'); } catch (e) {}
    }
  }

  function initMagnetic() {
    if (window.matchMedia('(hover: none)').matches) return;
    var els = document.querySelectorAll('[data-yv-magnetic], .theme-cta');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        if (el.hasAttribute('data-yv-mag-ready')) return;
        el.setAttribute('data-yv-mag-ready', '');
        var box = null;
        el.addEventListener('mouseenter', function () { box = el.getBoundingClientRect(); });
        el.addEventListener('mousemove', function (e) {
          if (!box) box = el.getBoundingClientRect();
          var dx = (e.clientX - (box.left + box.width / 2)) * 0.2;
          var dy = (e.clientY - (box.top + box.height / 2)) * 0.28;
          el.style.transform = 'translate3d(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px,0)';
        });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; box = null; });
      })(els[i]);
    }
  }

  function initCue() {
    var hero = document.querySelector('#MainContent > [id$="hero"] > section');
    if (!hero || hero.querySelector('.yv-cue')) return;
    if (window.getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
    var cue = document.createElement('span');
    cue.className = 'yv-cue';
    cue.setAttribute('aria-hidden', 'true');
    cue.innerHTML = '<span class="yv-cue__text">Scroll</span><span class="yv-cue__line"></span>';
    hero.appendChild(cue);
    cueEl = cue;
  }
  var cueEl = null;

  function initCursor() {
    if (!on('cursor') || lowEnd) return;
    if (window.matchMedia('(hover: none)').matches || window.innerWidth < 1024) return;
    cursor = document.createElement('div');
    cursor.className = 'yv-cursor';
    cursor.innerHTML = '<span class="yv-cursor__dot"></span>';
    document.body.appendChild(cursor);
    // 좌표만 담고 끝낸다. 무엇 위에 있는지 판정은 프레임 루프에서 드물게 한다.
    window.addEventListener('mousemove', function (e) {
      cur.tx = e.clientX; cur.ty = e.clientY; cur.target = e.target;
      if (!cur.on) { cur.on = true; cursor.classList.add('yv-cursor--on'); }
      wake();
    }, { passive: true });
    document.addEventListener('mouseleave', function () {
      cur.on = false; cursor.classList.remove('yv-cursor--on');
    });
  }
  var cur = { x: 0, y: 0, tx: 0, ty: 0, target: null, on: false, checkAt: 0 };

  function checkCursorTarget(now) {
    if (!cursor || !cur.target) return;
    if (now - cur.checkAt < 140) return;      // 초당 7번이면 충분하다
    cur.checkAt = now;
    var t = cur.target;
    if (!t.closest) return;
    cursor.classList.toggle('yv-cursor--hot',
      !!t.closest('a, button, input, [data-yv-magnetic], .yv-deck__card, .yv-hl__row'));
    cursor.classList.toggle('yv-cursor--ink', !!t.closest('.yv-on-cream'));
  }

  function initChrome() {
    progress = document.createElement('div');
    progress.className = 'yv-progress';
    document.body.appendChild(progress);

    if (on('progressRing')) {
      ringTop = document.createElement('button');
      ringTop.className = 'yv-ring-top';
      ringTop.type = 'button';
      ringTop.setAttribute('aria-label', 'Back to top');
      ringTop.innerHTML =
        '<svg viewBox="0 0 40 40" fill="none">' +
        '<circle class="yv-ring-top__track" cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.4"/>' +
        '<circle class="yv-ring-top__bar" cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.4" pathLength="100" stroke-linecap="round"/>' +
        '<path class="yv-ring-top__arrow" d="M20 25 V15 M15.5 19.5 L20 15 L24.5 19.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';
      ringTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
      document.body.appendChild(ringTop);
    }

    marquee = document.querySelector('[id^="shopify-section"][id$="marquee"] > section');
  }


  /* ================= 신규 섹션 10종 ================= */

  var procs = [], highlights = [], vids = [];

  function observeAll(sel, cls) {
    var els = document.querySelectorAll(sel + ':not([data-yv-obs])');
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('data-yv-obs', '');
      io.observe(els[i]);
    }
  }

  function initNewSections() {
    // 등장만 하면 되는 것들
    observeAll('[data-yv-ed-tile]');
    observeAll('[data-yv-quote]');
    observeAll('[data-yv-schedule]');
    observeAll('[data-yv-logos]');
    observeAll('[data-yv-proc-step]');

    // 프로세스 — 스크롤에 따라 선이 그어진다
    var ps = document.querySelectorAll('[data-yv-process]:not([data-yv-proc-ready])');
    for (var i = 0; i < ps.length; i++) {
      ps[i].setAttribute('data-yv-proc-ready', '');
      procs.push({ wrap: ps[i], fill: ps[i].querySelector('[data-yv-proc-fill]'), top: 0, h: 0 });
    }

    // 하이라이트 텍스트 — 화면 중앙을 지나는 단어가 밝아진다
    var hs = document.querySelectorAll('[data-yv-highlight]:not([data-yv-hlg-ready])');
    for (var k = 0; k < hs.length; k++) {
      hs[k].setAttribute('data-yv-hlg-ready', '');
      highlights.push({ wrap: hs[k], words: hs[k].querySelectorAll('.yv-hlg__w'), top: 0, h: 0, last: -1 });
    }

    // 비디오 밴드 — 스크롤에 따라 아주 살짝 줌아웃
    var vs = document.querySelectorAll('[data-yv-video]:not([data-yv-vid-ready])');
    for (var v = 0; v < vs.length; v++) {
      vs[v].setAttribute('data-yv-vid-ready', '');
      vids.push({ wrap: vs[v], frame: vs[v].querySelector('[data-yv-vid-frame]'), top: 0, h: 0 });
    }

    initCompare();
    initSpotlight();
    initFooter();
    initPromo();
  }

  /* ---- 프로모션 팝업 ---- */
  function initPromo() {
    var promo = document.querySelector('[data-yv-promo]');
    if (!promo || promo.hasAttribute('data-yv-promo-ready')) return;
    promo.setAttribute('data-yv-promo-ready', '');

    var freq = promo.getAttribute('data-yv-promo-freq') || 'day';
    var delay = (parseFloat(promo.getAttribute('data-yv-promo-delay')) || 0) * 1000;
    var KEY = 'yv-promo-seen';

    function seen() {
      if (freq === 'always' || editor) return false;
      try {
        if (freq === 'session') return sessionStorage.getItem(KEY) === '1';
        var v = localStorage.getItem(KEY);
        if (!v) return false;
        var days = freq === 'week' ? 7 : 1;
        return (Date.now() - parseInt(v, 10)) < days * 86400000;
      } catch (e) { return false; }
    }
    function remember() {
      try {
        if (freq === 'session') sessionStorage.setItem(KEY, '1');
        else localStorage.setItem(KEY, String(Date.now()));
      } catch (e) {}
    }

    function open() {
      promo.hidden = false;
      // 다음 프레임에 클래스를 붙여야 전환이 실제로 재생된다
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { promo.classList.add('is-open'); });
      });
      remember();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      promo.classList.remove('is-open');
      promo.classList.add('is-closing');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () {
        promo.hidden = true;
        promo.classList.remove('is-closing');
      }, 430);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    var closers = promo.querySelectorAll('[data-yv-promo-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);

    var codeBtn = promo.querySelector('[data-yv-promo-code]');
    if (codeBtn) {
      codeBtn.addEventListener('click', function () {
        var code = codeBtn.getAttribute('data-yv-promo-code') || '';
        var hint = codeBtn.querySelector('[data-yv-promo-hint]');
        var done = function () {
          codeBtn.classList.add('is-copied');
          if (hint) { var old = hint.textContent; hint.textContent = 'Copied'; 
            setTimeout(function () { hint.textContent = old; codeBtn.classList.remove('is-copied'); }, 2200); }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var t = document.createElement('textarea');
          t.value = code; document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(t); done();
        }
      });
    }

    if (editor) { open(); return; }          // 편집기에서는 바로 보여 준다
    if (seen()) return;
    // 인트로가 끝난 뒤부터 시간을 센다
    var wait = root.classList.contains('yv-intro-active') ? INTRO_END + delay : delay;
    setTimeout(open, Math.max(600, wait));
  }

  function initFooter() {
    var bs = document.querySelectorAll('[data-yv-foot-toggle]:not([data-yv-foot-ready])');
    for (var i = 0; i < bs.length; i++) {
      (function (btn) {
        btn.setAttribute('data-yv-foot-ready', '');
        btn.addEventListener('click', function () {
          var wrap = btn.closest('[data-yv-foot-company]');
          if (!wrap) return;
          var open = wrap.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          setTimeout(measure, 650);
        });
      })(bs[i]);
    }
  }

  function initCompare() {
    var els = document.querySelectorAll('[data-yv-compare]:not([data-yv-cmp-ready])');
    for (var i = 0; i < els.length; i++) {
      (function (wrap) {
        wrap.setAttribute('data-yv-cmp-ready', '');
        var range = wrap.querySelector('[data-yv-cmp-range]');
        if (!range) return;
        function apply() { wrap.style.setProperty('--yv-cmp', range.value + '%'); }
        range.addEventListener('input', apply);
        apply();
      })(els[i]);
    }
  }

  function initSpotlight() {
    if (window.matchMedia('(hover: none)').matches) return;
    var els = document.querySelectorAll('[data-yv-sp-stage]:not([data-yv-sp-ready])');
    for (var i = 0; i < els.length; i++) {
      (function (stage) {
        stage.setAttribute('data-yv-sp-ready', '');
        var card = stage.querySelector('[data-yv-sp-card]');
        if (!card) return;
        var box = null;
        stage.addEventListener('mouseenter', function () { box = stage.getBoundingClientRect(); });
        stage.addEventListener('mousemove', function (e) {
          if (!box) box = stage.getBoundingClientRect();
          var px = (e.clientX - box.left) / box.width - 0.5;
          var py = (e.clientY - box.top) / box.height - 0.5;
          card.style.setProperty('--yv-ry', (px * 13).toFixed(2) + 'deg');
          card.style.setProperty('--yv-rx', (-py * 10).toFixed(2) + 'deg');
        });
        stage.addEventListener('mouseleave', function () {
          card.style.setProperty('--yv-ry', '0deg');
          card.style.setProperty('--yv-rx', '0deg');
          box = null;
        });
      })(els[i]);
    }
  }

  function renderNewSections(y) {
    var i, p;

    for (i = 0; i < procs.length; i++) {
      var pr = procs[i];
      if (!pr.fill) continue;
      if (pr.top + pr.h < y || pr.top > y + vh) continue;
      p = clamp01((y + vh * 0.62 - pr.top) / Math.max(1, pr.h));
      pr.fill.style.setProperty('--yv-proc', p.toFixed(3));
    }

    for (i = 0; i < highlights.length; i++) {
      var hl = highlights[i];
      var n = hl.words.length;
      if (!n) continue;
      if (hl.top + hl.h < y || hl.top > y + vh) continue;
      p = clamp01((y + vh * 0.72 - hl.top) / Math.max(1, hl.h + vh * 0.25));
      var upto = Math.round(p * n);
      if (upto === hl.last) continue;
      hl.last = upto;
      for (var k = 0; k < n; k++) hl.words[k].classList.toggle('is-on', k < upto);
    }

    for (i = 0; i < vids.length; i++) {
      var vd = vids[i];
      if (!vd.frame) continue;
      if (vd.top + vd.h < y || vd.top > y + vh) continue;
      var c = vd.top + vd.h / 2 - (y + vh / 2);
      vd.frame.style.setProperty('--yv-vid-zoom', (1.06 + Math.abs(c) / vh * 0.05).toFixed(3));
    }
  }

  /* ================= 측정 (읽기는 여기서만) ================= */

  function cache(list) {
    for (var i = 0; i < list.length; i++) {
      var r = list[i].wrap ? list[i].wrap.getBoundingClientRect() : list[i].el.getBoundingClientRect();
      list[i].top = r.top + scrollY;
      list[i].h = r.height;
    }
  }

  var cvSections = null;

  function collectCv() {
    if (cvSections) return;
    cvSections = [];
    if (!('contentVisibility' in document.documentElement.style)) return;
    var secs = document.querySelectorAll('#MainContent > [id^="shopify-section"]');
    // 첫 섹션(히어로)만 항상 그린다. 나머지는 화면 근처일 때만.
    for (var i = 1; i < secs.length; i++) cvSections.push(secs[i]);
  }

  function clearContentVisibility() {
    collectCv();
    for (var k = 0; k < cvSections.length; k++) cvSections[k].classList.remove('yv-cv');
  }

  function applyContentVisibility() {
    for (var k = 0; k < cvSections.length; k++) {
      var el = cvSections[k];
      var h = Math.round(el.getBoundingClientRect().height);
      if (h > 0) {
        el.style.containIntrinsicSize = '1px ' + h + 'px';
        el.classList.add('yv-cv');
      }
    }
  }

  function measure() {
    // 재기 전에 잠깐 전부 펼쳐야 실제 높이가 나온다
    clearContentVisibility();
    scrollY = window.pageYOffset;
    vh = window.innerHeight;
    vw = window.innerWidth;
    docH = Math.max(1, document.documentElement.scrollHeight - vh);

    cache(parallaxItems);
    cache(decks);
    cache(hscrolls);
    cache(stories);
    cache(masks);
    cache(colsets);
    cache(splitsts);
    cache(signupZones);
    cache(procs);
    cache(highlights);
    cache(vids);

    for (var i = 0; i < hscrolls.length; i++) {
      var t = hscrolls[i].track;
      hscrolls[i].max = t ? Math.max(0, t.scrollWidth - vw) : 0;
    }
    applyContentVisibility();
    render();
  }

  /* ================= 렌더 (쓰기만) ================= */

  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  function render() {
    var y = scrollY;
    var pct = clamp01(y / docH);

    if (progress) progress.style.transform = 'scaleX(' + pct.toFixed(4) + ')';

    if (ringTop) {
      ringTop.style.setProperty('--yv-pct', pct.toFixed(3));
      ringTop.classList.toggle('yv-on', y > vh * 0.6);
    }

    if (cueEl) cueEl.classList.toggle('yv-cue--gone', y > 80);

    if (sticky) {
      var overlap = false;
      for (var q = 0; q < signupZones.length; q++) {
        var z = signupZones[q];
        if (z.top < y + vh * 0.9 && z.top + z.h > y + vh * 0.1) { overlap = true; break; }
      }
      var stickyOn = pct > stickyAfter;
      sticky.classList.toggle('yv-on', stickyOn);
      sticky.classList.toggle('yv-hide', overlap);
      if (ringTop) ringTop.classList.toggle('yv-raised', stickyOn && !overlap);
    }

    if (marquee) {
      var drag = Math.max(-56, Math.min(56, (y - lastY) * -2.2));
      marquee.style.setProperty('--yv-drag', drag.toFixed(1) + 'px');
    }
    lastY = y;

    var i, p, item;

    for (i = 0; i < parallaxItems.length; i++) {
      item = parallaxItems[i];
      if (item.top + item.h < y - 200 || item.top > y + vh + 200) continue;
      var center = item.top + item.h / 2 - (y + vh / 2);
      item.el.style.setProperty('--yv-py', (-center * item.speed).toFixed(1) + 'px');
    }

    for (i = 0; i < hscrolls.length; i++) {
      var hsc = hscrolls[i];
      if (hsc.top + hsc.h < y || hsc.top > y + vh || !hsc.track) continue;
      var travel = hsc.h - vh;
      p = travel > 0 ? clamp01((y - hsc.top) / travel) : 0;
      hsc.track.style.transform = 'translate3d(' + (-hsc.max * p).toFixed(1) + 'px,0,0)';
      if (hsc.bar) hsc.bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }

    for (i = 0; i < stories.length; i++) {
      var stt = stories[i];
      if (stt.top + stt.h < y || stt.top > y + vh) continue;
      var n = stt.lines.length;
      if (!n) continue;
      var tr = stt.h - vh;
      p = tr > 0 ? clamp01((y - stt.top) / tr) : 0;
      var idx = Math.min(n - 1, Math.floor(p * n));
      if (idx === stt.current) continue;
      stt.current = idx;
      for (var k = 0; k < n; k++) {
        stt.lines[k].classList.toggle('is-on', k === idx);
        if (stt.dots[k]) stt.dots[k].classList.toggle('is-on', k === idx);
      }
    }

    for (i = 0; i < masks.length; i++) {
      var m = masks[i];
      if (!m.shape) continue;
      if (m.top + m.h < y || m.top > y + vh) continue;
      var mt = m.h - vh;
      p = mt > 0 ? clamp01((y - m.top) / mt) : 0;
      // 사진이 화면을 가득 채운 상태에서 시작해, 스크롤할수록 로고 모양으로 좁혀진다.
      // (transform 만 움직여서 합성만 일어난다 = 부드럽다)
      var scale = 1 + Math.pow(1 - p, 1.4) * 13;
      m.shape.style.transform = 'scale(' + scale.toFixed(3) + ')';
      if (m.img) m.img.style.transform = 'scale(' + (1 / scale).toFixed(5) + ')';
      // 로고가 다 좁혀질 즈음 문구가 떠오른다
      if (m.copy) {
        var t = clamp01((p - 0.62) / 0.28);
        m.copy.style.opacity = t.toFixed(3);
        m.copy.style.transform = 'translate3d(0,' + ((1 - t) * 1.6).toFixed(2) + 'rem,0)';
      }
    }

    for (i = 0; i < colsets.length; i++) {
      var cset = colsets[i];
      if (cset.top + cset.h < y - 200 || cset.top > y + vh + 200) continue;
      var cc = cset.top + cset.h / 2 - (y + vh / 2);
      for (var ci = 0; ci < cset.inners.length; ci++) {
        var sp = [-0.2, 0.15, -0.28][ci % 3];
        cset.inners[ci].style.transform = 'translate3d(0,' + (cc * sp).toFixed(1) + 'px,0)';
      }
    }

    for (i = 0; i < splitsts.length; i++) {
      var ss = splitsts[i];
      if (ss.top + ss.h < y || ss.top > y + vh) continue;
      var mid = ss.top + ss.h / 2 - y;
      p = clamp01(1 - mid / vh);
      var e = Math.min(1, p * 1.4);
      ss.el.style.setProperty('--yv-sa', (-13 + e * 13).toFixed(2) + '%');
      ss.el.style.setProperty('--yv-sb', (13 - e * 13).toFixed(2) + '%');
      ss.el.style.setProperty('--yv-sr', e.toFixed(3));
    }

    renderNewSections(y);

    for (i = 0; i < decks.length; i++) {
      var dk = decks[i];
      if (!dk.el.classList.contains('yv-in')) continue;
      if (dk.top + dk.h < y || dk.top > y + vh) continue;
      var dp = (dk.top + dk.h / 2 - (y + vh / 2)) / vh;
      for (var dj = 0; dj < dk.cards.length; dj++) {
        var off = dj - (dk.cards.length - 1) / 2;
        dk.cards[dj].style.setProperty('--yv-scrub', (dp * off * 8).toFixed(1) + 'px');
        dk.cards[dj].style.setProperty('--yv-scrub-rot', (dp * off * 0.8).toFixed(2) + 'deg');
      }
    }
  }

  var lastY = 0;

  /* ================= 프레임 감시견 =================
     스크롤하는 동안 실제 프레임 간격을 재서, 버거우면 스스로 가볍게 전환한다.
     기기 사양을 추측하는 것보다 확실하다. */

  var fpsWin = [];
  var fpsRun = 0;
  var degraded = 0;

  function degrade() {
    degraded++;
    if (degraded === 1) {
      root.classList.add('yv-lite');
      // 가장 비싼 것부터 끈다
      for (var i = 0; i < parallaxItems.length; i++) {
        parallaxItems[i].el.style.removeProperty('--yv-py');
      }
      parallaxItems.length = 0;
      if (cursor && cursor.parentNode) { cursor.parentNode.removeChild(cursor); cursor = null; }
      for (var k = 0; k < peeks.length; k++) peeks[k].peek.classList.remove('is-on');
      peeks.length = 0;
    } else if (degraded === 2) {
      // 그래도 버거우면 스크롤 연동 장식까지 정지
      root.classList.add('yv-static');
      decks.length = 0;
      colsets.length = 0;
      splitsts.length = 0;
      vids.length = 0;
    }
    fpsWin.length = 0;
  }

  function watchFrame(dt) {
    if (degraded >= 2) return;
    if (dt > 200) return;                 // 탭 전환·이미지 디코드 같은 일회성은 무시
    fpsWin.push(dt);
    if (dt > 34) { fpsRun++; } else { fpsRun = 0; }
    if (fpsRun >= 6) { degrade(); fpsRun = 0; return; }   // 연속으로 6프레임 밀리면 바로
    if (fpsWin.length < 60) return;
    var slow = 0;
    for (var i = 0; i < fpsWin.length; i++) if (fpsWin[i] > 26) slow++;
    if (slow > fpsWin.length * 0.22) degrade();
    else fpsWin.length = 0;
  }

  /* ================= 하나의 rAF 루프 ================= */

  var running = false;
  var idle = 0;
  var lastFrameAt = 0;

  function frame() {
    var moved = false;
    var now = performance.now();
    if (lastFrameAt) watchFrame(now - lastFrameAt);
    lastFrameAt = now;

    if (cursor) {
      checkCursorTarget(now);
      var dx = cur.tx - cur.x, dy = cur.ty - cur.y;
      if (Math.abs(dx) > 0.15 || Math.abs(dy) > 0.15) {
        cur.x += dx * 0.16; cur.y += dy * 0.16;
        cursor.style.transform = 'translate3d(' + cur.x.toFixed(1) + 'px,' + cur.y.toFixed(1) + 'px,0)';
        moved = true;
      }
    }

    for (var i = 0; i < peeks.length; i++) {
      var pk = peeks[i];
      var px = pk.tx - pk.x, py = pk.ty - pk.y;
      if (Math.abs(px) > 0.2 || Math.abs(py) > 0.2) {
        pk.x += px * 0.11; pk.y += py * 0.11;
        pk.peek.style.transform =
          'translate3d(' + (pk.x - 0).toFixed(1) + 'px,' + (pk.y - 0).toFixed(1) + 'px,0) translate(-50%,-50%)';
        moved = true;
      }
    }

    if (needsRender) { needsRender = false; render(); moved = true; }

    idle = moved ? 0 : idle + 1;
    if (idle > 40) { running = false; lastFrameAt = 0; fpsWin.length = 0; return; }
    requestAnimationFrame(frame);
  }

  function wake() {
    idle = 0;
    if (running) return;
    running = true;
    requestAnimationFrame(frame);
  }

  var needsRender = false;

  function onScroll() {
    scrollY = window.pageYOffset;
    needsRender = true;
    wake();
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measure, 140);
  }

  /* ================= 시작 ================= */

  function boot() {
    root.setAttribute('data-yv-booted', '');
    tagAll();
    initSeams();
    joinCreamRuns();
    initTickers();
    initDecks();
    initHscroll();
    initStory();
    initMasks();
    initCols();
    initSplitStatements();
    initWordmarks();
    initSignupSections();
    initCounts();
    initCycles();
    initStats();
    initAccordions();
    initHoverList();
    initSticky();
    initMagnetic();
    initNewSections();
    initCue();
    initCursor();
    initChrome();

    lastY = window.pageYOffset;
    measure();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    setTimeout(measure, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (editor) {
    document.addEventListener('shopify:section:load', function () {
      tagAll(); initSeams(); joinCreamRuns(); initTickers(); initDecks(); initHscroll(); initStory();
      initMasks(); initCols(); initSplitStatements(); initWordmarks(); initSignupSections();
      initCounts(); initCycles(); initStats(); initAccordions(); initHoverList();
      initNewSections(); initMagnetic();
      measure();
    });
  }
})();
